/**
 * Genesis root withdrawal-spawn: first child (e.g. AFP-000014) pays mahesh ₹150 CO.
 * Mahesh L1 payments 2–3 come from roster AFP-000015 & AFP-000016 (see MAHESH_SERIAL_L2_FLOW.md).
 */
export const ROOT_SPAWN_PAIR_COUNT = 14;

/** @param {number} spawnChildIndex — 1-based spawn children on AFP-000001 */
export function rootSpawnPairIndexForChild(spawnChildIndex) {
  const n = Number(spawnChildIndex);
  if (n < 1) return null;
  return Math.ceil(n / 2);
}

/** First spawn child pays upline enrollment 5 (mahesh); later pairs TBD. */
export function rootSpawnUplineEnrollmentSeqForPair(pairIndex) {
  const p = Number(pairIndex);
  if (p === 1) return 5;
  if (p >= 2 && p <= ROOT_SPAWN_PAIR_COUNT) {
    return 4 + p;
  }
  return null;
}

export function rootSpawnUplineEnrollmentSeqForSpawnChild(spawnChildIndex) {
  const pair = rootSpawnPairIndexForChild(spawnChildIndex);
  if (pair == null) return null;
  return rootSpawnUplineEnrollmentSeqForPair(pair);
}

export function isFirstChildOfRootSpawnPair(spawnChildIndex) {
  return Number(spawnChildIndex) % 2 === 1;
}

export const ROOT_SPAWN_FILL_SOURCE = "ROOT_SPAWN_CHILD";

export const MAHESH_L1_SPAWN_FILLER = "AFP-000014";
export const MAHESH_L1_ROSTER_UPGRADE_FILLERS = ["AFP-000015", "AFP-000016"];
